import React from 'react'
import {ButtonProps} from 'wix-ui-tpa/Button'
import {Button as ButtonUI} from 'wix-ui-tpa/dist/src/components/Button/Button'
import classnames from 'classnames'
import {classes} from './button.st.css'

export const Button: React.FC<ButtonProps> = ({className, ...rest}) => (
  <ButtonUI {...rest} className={classnames(classes.root, className)} upgrade />
)
